import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AppProvider, useAppContext } from "./contexts/AppContext";
import "./components/Css/style.css";
import Navbar from "./components/Header/Navbar";
import AboutUs from "./components/AboutUs/AboutUs";
import Services from "./components/Services/Services";
import Products from "./components/Products/Products";
import Portfolio from "./components/Portfolio/Portfolio";
import Blogs from "./components/Blog/Blog";
import Contact from "./components/Contact/Contact";
import ContentManagementForm from "./components/AdminDashboard/ContentManagementForm";
import Footer from "./components/Footer/Footer";
import TestimonialDisplay from "./components/testimonials/testimonials";
import Login from "./components/LogIn/LogIn";
import Register from "./components/Register/Register";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "./components/Detail/Detail";
import LandingPage from "./components/LandingPage";
import Loading from "./components/Loading/Loading";

function PrivateRoute({ children }) {
  const { isAdmin } = useAppContext();
  const navigate = useNavigate();
  React.useEffect(() => {
    if (!isAdmin) {
      navigate("/login");
    }
  }, [isAdmin, navigate]);

  if (!isAdmin) return null;
  return children;
}

function AppContent() {
  const { isHomeLoaded } = useAppContext();
  const location = useLocation();

  if (!isHomeLoaded) {
    return <Loading />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/register"
          element={
            <PrivateRoute>
              <Register />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <ContentManagementForm />
            </PrivateRoute>
          }
        />
        <Route path="/testimonials" element={<TestimonialDisplay />} />
        <Route path="/details" element={<Detail />} />
        <Route path="/about/:id" element={<Detail />} />
        <Route path="/services/:id" element={<Detail />} />
        <Route path="/doctors/:id" element={<Detail />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <Router>
        <AppContent />
      </Router>
    </AppProvider>
  );
}

export default App;
